import React, { createContext } from "react";
import { Context} from "react";

export const locationContext=createContext(""); 